export default __webpack_public_path__ + "static/media/01.6ee64083.jpg";